import { Checkbox } from '@mui/material';
import React from 'react';
import CheckedXIcon from '../../shared/components/CheckedXIcon';
import SkeletonWrapper from '../../shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} ShareFutureDataCheckBoxProps
 * @property {boolean} isSelectAll
 * @property {boolean} shareFutureData
 * @property {(checked: boolean) => void} setShareFutureData
 * @property {boolean} isEdit
 * @property {boolean} [loading]
 */

/**
 * @param {ShareFutureDataCheckBoxProps} props
 */
const ShareFutureDataCheckBox = props => {
  const {
    setShareFutureData,
    shareFutureData = false,
    isSelectAll = false,
    isEdit = false,
    loading = false
  } = props;

  return (
    <div className='checkbox-wrapper'>
      <SkeletonWrapper show={loading}>
        <Checkbox
          id='select-include-higher-levels'
          value={shareFutureData}
          size='small'
          checked={shareFutureData}
          checkedIcon={<CheckedXIcon size='small' />}
          onChange={e => setShareFutureData(e.target.checked)}
          color='default'
          disabled={!isSelectAll || !isEdit}
        />
      </SkeletonWrapper>
      <span className='checkbox-label-small'>Share future data with FDA</span>
    </div>
  );
};

export default ShareFutureDataCheckBox;
